import { render, staticRenderFns } from "./Step_2_InfoStep.vue?vue&type=template&id=1ecafce2&scoped=true&"
import script from "./Step_2_InfoStep.vue?vue&type=script&lang=js&"
export * from "./Step_2_InfoStep.vue?vue&type=script&lang=js&"
import style0 from "./Step_2_InfoStep.vue?vue&type=style&index=0&id=1ecafce2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecafce2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCol,VIcon,VRow,VTextarea,VTooltip})
